import { type ActivationLifecycle } from '@/infra/activation'
import { InfiniteScrollProvider } from '@/infra/InfiniteScrollProvider'
import { LifecycleTracker } from '@/infra/lifecycle-tracker'
import { type SnackbarRetryWrapperFactory } from '@/features/shell'
import { type Section7216Store } from '@/features/account/section-7216/Section7216Store'
import { tap } from 'rxjs/operators'
import type { Workspace } from '@/features/iam/workspaces/Workspace'
import { computed } from 'mobx'

export class Section7216AcceptancesListViewModel implements ActivationLifecycle {
  private readonly _lifecycle = new LifecycleTracker()

  readonly scroller = new InfiniteScrollProvider({
    limit: 10,
    fetchItems: ({ paging, signal }) => {
      const withRetry = this._createSnackbarRetryWrapper(
        'Unable to load authorizations',
        signal,
      )
      return withRetry(() => this._store.listAcceptances(paging, signal))
    },
  })

  constructor(
    private readonly _getCurrentWorkspace: () => Workspace,
    private readonly _createSnackbarRetryWrapper: SnackbarRetryWrapperFactory,
    private readonly _store: Section7216Store,
  ) {
    this._lifecycle.manage(this._store.accepted$.pipe(tap(() => this.fetch())))
  }

  @computed
  get workspace() {
    return this._getCurrentWorkspace()
  }

  activate() {
    this._lifecycle.activate()
    if (this.workspace.config.section7216.enabled) {
      void this.fetch()
    }
  }

  deactivate() {
    this._lifecycle.deactivate()
  }

  private fetch() {
    return this.scroller.fetch({ signal: this._lifecycle.signal })
  }
}
